module.exports = __webpack_public_path__ + "img/2026-03.e68dc827.jpg";